/**
 * Registro de plantillas de presentación.
 * Cada plantilla exporta: config (para el backend) y un componente Preview.
 * Añade aquí nuevas plantillas al crear archivos en esta carpeta.
 */
import PlantillaSimple, { config as configSimple } from "./PlantillaSimple";
import Plantilla1Preview, { config as configPlantilla1 } from "./Plantilla1";
import LookbookPreview, { config as configLookbook } from "./PlantillaLookbook";
import FichaTecnicaPreview, { config as configFichaTecnica } from "./PlantillaFichaTecnica";
import EditorialPreview, { config as configEditorial } from "./PlantillaEditorial";
import CollectionBoardPreview, { config as configCollectionBoard } from "./PlantillaCollectionBoard";
import PremiumEditorialPreview, {
  config as configPremiumEditorial,
} from "./PlantillaPremiumEditorial";
import PremiumTechpackPreview, {
  config as configPremiumTechpack,
} from "./PlantillaPremiumTechpack";
import ColorOptionsProPreview, {
  config as configColorOptionsPro,
} from "./PlantillaColorOptionsPro";
import PrintedJacketsProPreview, {
  config as configPrintedJacketsPro,
} from "./PlantillaPrintedJacketsPro";
import PPTBikerProPreview, {
  config as configPPTBikerPro,
} from "./PlantillaPPTBikerPro";

export const plantillasRegistry = [
  {
    id: "PLANTILLA_SIMPLE",
    name: "SDS Photo Display",
    description: "Cabecera Stage + front/back a ancho + pie (patrón Muestras PDF)",
    config: configSimple,
    Preview: PlantillaSimple,
  },
  {
    id: "PLANTILLA_1",
    name: "Plantilla 1",
    config: configPlantilla1,
    Preview: Plantilla1Preview,
  },
  {
    id: "LOOKBOOK",
    name: "Lookbook",
    config: configLookbook,
    Preview: LookbookPreview,
  },
  {
    id: "FICHA_TECNICA",
    name: "Ficha Técnica",
    config: configFichaTecnica,
    Preview: FichaTecnicaPreview,
  },
  {
    id: "EDITORIAL",
    name: "Editorial",
    config: configEditorial,
    Preview: EditorialPreview,
  },
  {
    id: "COLLECTION_BOARD",
    name: "Collection Board",
    config: configCollectionBoard,
    Preview: CollectionBoardPreview,
  },
  {
    id: "PREMIUM_EDITORIAL",
    name: "Premium Editorial",
    description: "Editorial layout with hero garment + detail stack",
    config: configPremiumEditorial,
    Preview: PremiumEditorialPreview,
  },
  {
    id: "PREMIUM_TECHPACK",
    name: "Premium Techpack",
    description: "Technical board with front/back and detail panels",
    config: configPremiumTechpack,
    Preview: PremiumTechpackPreview,
  },
  {
    id: "PRO_COLOR_OPTIONS_3833_409",
    name: "Color Options Pro",
    description: "Inspired by COLOR OPTIONS 3833/409",
    config: configColorOptionsPro,
    Preview: ColorOptionsProPreview,
  },
  {
    id: "PRO_PRINTED_JACKETS",
    name: "Printed Jackets Pro",
    description: "Inspired by NEW OPTS PRINTED JACKETS",
    config: configPrintedJacketsPro,
    Preview: PrintedJacketsProPreview,
  },
  {
    id: "PRO_PPT_BIKER_JACKET",
    name: "PPT Biker Jacket Pro",
    description: "Inspired by PPT BIKER JACKET",
    config: configPPTBikerPro,
    Preview: PPTBikerProPreview,
  },
];

export default plantillasRegistry;
